import { Title } from '@angular/platform-browser';
import { MenuCompositionsComponent } from './../menu-compositions/menu-compositions.component';
import { ToastrService } from 'ngx-toastr';
import { MenuModalComponent } from './../../modules/modals/menu-modal/menu-modal.component';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PdvService } from './../../services/pdv/pdv.service';
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { OrdersService } from '@app/services/order/orders.service';

@Component({
    selector: 'menu-card',
    templateUrl: 'menu.component.html',
    styleUrls: ['menu.component.scss']
})

export class MenuComponent{

    @Input()
    menu;
    loadAvatar = false;
    siteClose = false;
    subscriptions2: Subscription[] = [];
    compositions:any[]=[];
    bsModalRef: BsModalRef;
    chosenOrderType: number;
    nbrOffersAuthorizedSite: number;
    offerNbr: number;
    @ViewChild('template') template: ElementRef;
    constructor(
        private pdvService:PdvService,
        private modalService: BsModalService,
        private orderService: OrdersService,
        private router: Router,
        private toastr: ToastrService
    ){
        const sub1=this.pdvService.pdv.subscribe(
            (data) => {
                this.siteClose = data.closeSite;
            }
        )
        const sub2=this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
        });
        const subs3 = this.pdvService.nbrOffersAuthorizedSite.subscribe((nbrOffersAuthorizedSite: number) => {
            this.nbrOffersAuthorizedSite = nbrOffersAuthorizedSite;
        });
        const subs4 = this.orderService.offerNbr.subscribe((offerNbr: any) => {
            this.offerNbr = offerNbr;
        });
        this.subscriptions2.push(sub1, sub2,subs3,subs4);
    }
    
    addToBasket() {
        if (this.chosenOrderType > 0) {
            if (this.menu.offer == null || (this.menu.offer != null && this.offerNbr < this.nbrOffersAuthorizedSite)) {
                this.bsModalRef = this.modalService.show(MenuModalComponent, { class: 'modal-content3' });
                this.bsModalRef.content.menu = this.menu;
            } else {
                this.toastr.error('', 'Vous avez atteint le nombre d\'offre autorisée');
            }
        } else {
            this.router.navigate(["/modes"], { queryParams: {menu:this.menu.slug} });
        }
    }

    closemodel(){
        if(this.bsModalRef){
            this.bsModalRef.hide();
        }
    }

    showComposition(){
        this.compositions=[];
        for(let j=0;j<11;j++){
            let comp=this.menu.compositions.elements[j].concat(this.menu.compositions.families[j]);
            this.compositions.push(comp);
        }
        this.bsModalRef = this.modalService.show(MenuCompositionsComponent,{class:"composition-modal"});
        this.bsModalRef.content.compositions= this.compositions;
        this.bsModalRef.content.label=this.menu.title
    }
    
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }
}
